export default class CatalogPage {
  constructor(page) {
    this.addConfig = page.addConfig;
    this.catalogSectionIds = page.catalogSectionIds;
    this.description = page.description;
    this.disableButtonText = page.disableButtonText;
    this.enableButtonPrefix = page.enableButtonPrefix;
    this.enabledButtonText = page.enabledButtonText;
    this.heroImageId = page.heroImageId;
    this.iconId = page.iconId;
    this.id = page.id;
    this.marquees = page.marquees;
    this.purchaseEnabled = page.purchaseEnabled;
    this.purchaseOrderId = page.purchaseOrderId;
    this.questionnaireId = page.questionnaireId;
    this.rating = page.rating;
    this.removeConfig = page.removeConfig;
    this.reviews = page.reviews;
    this.shortDescription = page.shortDescription;
    this.socialProof = page.socialProof;
    this.title = page.title;
    this.visibility = page.visibility;
    this.rateLimitAffirmativeButtonText = page.rateLimitAffirmativeButtonText;
    this.rateLimitNegativeButtonText = page.rateLimitAffirmativeButtonText;
    this.rateLimitSubtitle = page.rateLimitSubtitle;
    this.rateLimitTitle = page.rateLimitTitle;
  }

  static CATALOG_PAGE_STATUSES = {
    INACTIVE: 'INACTIVE',
    TRIAL: 'TRIAL',
    ACTIVE: 'ACTIVE',
  };

  activeCatalogPagePurchaseReceipts(store) {
    const receipts = this.catalogPagePurchaseReceipts(store);
    return receipts
      .filter(r => r.active)
      .sort((a, b) => b.expiresAt - a.expiresAt);
  }

  activePurchaseOrderId(store) {
    return this.activeCatalogPagePurchaseReceipts(store)[0]?.purchaseOrderId;
  }

  catalogPagePurchaseReceipts(store) {
    return store.getters['purchaseReceipts/all'].filter(pr => {
      const purchaseOrder = store.getters['purchaseOrders/get'][pr.purchaseOrderId];
      return purchaseOrder?.parentId === this.purchaseOrderId;
    });
  }

  catalogPagePurchaseOrders(store) {
    return store.getters['purchaseOrders/all']
      .filter(po => po.parentId === this.purchaseOrderId);
  }

  catalogPageRootPurchaseOrder(store) {
    return store.getters['purchaseOrders/get'][this.purchaseOrderId];
  }

  catalogPageStatus(store) {
    const activeReceipts = this.activeCatalogPagePurchaseReceipts(store);
    if (activeReceipts.length === 0) {
      return CatalogPage.CATALOG_PAGE_STATUSES.INACTIVE;
    }
    if (activeReceipts.length === 1) {
      const receiptPO = store.getters['purchaseOrders/get'][activeReceipts[0].purchaseOrderId];
      if (receiptPO?.isFree) {
        return CatalogPage.CATALOG_PAGE_STATUSES.TRIAL;
      }
      return CatalogPage.CATALOG_PAGE_STATUSES.ACTIVE;
    }
    const hasActivePaidReceipt = activeReceipts.some(r => {
      const receiptPO = store.getters['purchaseOrders/get'][r.purchaseOrderId];
      return !receiptPO.isFree;
    });
    if (activeReceipts.length > 1 && hasActivePaidReceipt) {
      return CatalogPage.CATALOG_PAGE_STATUSES.ACTIVE;
    }

    console.log('Unable to determine catalog page status');
  }

  isAddonActive(store) {
    return this.activeCatalogPagePurchaseReceipts(store).length > 0;
  }

  isAddonExpired(store) {
    const receipts = this.catalogPagePurchaseReceipts(store);
    const paidRealizedReceipts = receipts.filter(pr => {
      const po = store.getters['purchaseOrders/get'][pr.purchaseOrderId];
      return po && !po.isFree && !pr.unrealized;
    });
    const activeReceipts = this.activeCatalogPagePurchaseReceipts(store).filter(r => r.expiresAt);
    return paidRealizedReceipts.length > 0 && activeReceipts.length === 0;
  }

  getDashboardId(store) {
    return store.getters['dashboards/list']
      .filter(dashboard => dashboard.unlockedBy.includes(this.activePurchaseOrderId(store)))
      .map(dashboard => dashboard.id)[0];
  }
}
